import { ErrorBoundary } from "@circle-react-shared/ErrorPages/ErrorBoundary";

import { ChatError } from "./ChatError";
import type { ListProps } from "./List";
import { List } from "./List";

export const DMsList = (props: ListProps) => (
  <ErrorBoundary renderFunc={ChatError}>
    <List {...props} />
  </ErrorBoundary>
);
